/*
 * clebs-header.js
 * Sticky visual class + carousel mobile barre d'annonce
 * Clebs Concept Store — Thème Horizon
 */
(function () {
  'use strict';

  /* ─── Fixer --header-group-height au chargement ─── */
  function fixHeaderGroupHeight() {
    var headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;

    // Calculer la hauteur totale réelle du groupe header
    var totalHeight = 0;
    var children = headerGroup.children;
    for (var i = 0; i < children.length; i++) {
      totalHeight += children[i].offsetHeight;
    }

    // Appliquer avec !important via cssText pour bloquer les surcharges
    // Ajouter 1px pour padding/buffer
    document.body.style.cssText += '--header-group-height: ' + (totalHeight + 1) + 'px !important;';

    // Bloquer les modifications futures de cette variable par les autres scripts
    var originalSetProperty = document.body.style.setProperty;
    document.body.style.setProperty = function(prop, value, priority) {
      if (prop === '--header-group-height') {
        return; // Ignorer les tentatives de modification
      }
      return originalSetProperty.call(this, prop, value, priority);
    };
  }

  /* ─── Sticky scroll (desktop uniquement) ─── */
  function initSticky() {
    var header = document.getElementById('header-component');
    if (!header) return;

    var ticking = false;
    var THRESHOLD = 80;

    function updateSticky() {
      if (window.innerWidth >= 990) {
        if (window.scrollY >= THRESHOLD) {
          header.classList.add('is-sticky');
        } else {
          header.classList.remove('is-sticky');
        }
      } else {
        header.classList.remove('is-sticky');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateSticky);
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', updateSticky);
    updateSticky();
  }

  /* ─── Carrousel mobile barre d'annonce ─── */
  function initAnnouncementCarousel() {
    var carousel = document.querySelector('.announcement-bar__carousel');
    if (!carousel) return;

    var slides = Array.from(carousel.querySelectorAll('.announcement-bar__slide'));
    if (slides.length === 0) return;
    if (slides.length === 1) {
      slides[0].classList.add('is-active');
      return;
    }

    var current = 0;
    slides[0].classList.add('is-active');
    var INTERVAL = 4000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    function start() { timer = setInterval(function () { goTo(current + 1); }, INTERVAL); }
    function stop() { if (timer) clearInterval(timer); }

    var btnPrev = carousel.querySelector('.carousel-prev');
    var btnNext = carousel.querySelector('.carousel-next');
    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); });

  }

  /* ─── Initialisation ─── */
  function init() {
    fixHeaderGroupHeight();
    initSticky();
    initAnnouncementCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
